import React, { MouseEvent } from 'react';
import StudentPermitType from './StudentPermitType';
import { usePermitRequestContext } from '../../../../../contexts/PermitRequestContext';
import GoldenAgePermit from './GoldenAgePermit';
import DisabilityCardPermit from '../DisabilityCardPermit';
import { useProjectConfigContext } from '../../../../../contexts/ProjectConfigContext';
import BusinessPermitType from './BusinessPermitType';
import ZonePermitType from './ZonePermitType';


function PermitRequestType() {

    const { projectConfigState } = useProjectConfigContext();
    const projectId = projectConfigState.projectId;

    const { Formik } = usePermitRequestContext();
   
    const { setFieldValue } = Formik;

    if (projectId === 25) {
        return null;
    }

    return (
        <div className='col-12 mt-2'>
            <GoldenAgePermit handleClick={handleClick} />
            <StudentPermitType handleClick={handleClick} />
            <DisabilityCardPermit handleClick={handleClick} />
            <BusinessPermitType handleClick={handleClick} />
            <ZonePermitType handleClick={handleClick} />
        </div>
    );

    function handleClick(e: MouseEvent<HTMLInputElement>) {
        setFieldValue('permitType', Number(e.currentTarget.value));
    }
}


export default PermitRequestType;